<template>
  <div
    class="orm-mb-16 orm-col-xs-12 orm-col-sm-8 orm-col-md-6 orm-col-lg-4 orm-px-xs-8"
    v-if="filter"
    :rel="JSON.parse(JSON.stringify(car.toString()))"
  >
    <div
      class="orm-caroffers__element"
      :class="isOffer ? 'orm-caroffers__element--offer' : ''"
    >
      <div class="orm-slider__image__container">
        <Slider v-if="images" :images="images" :autoplay="true" />
        <div v-else :style="{ paddingTop: '75%' }"></div>
      </div>

      <div class="orm-cartitle">
        <h2 class="orm-headline__h2">
          {{ stripHTML(data[env.VUE_APP_RESERVATION_CARGROUP]) }}
        </h2>
        <p class="orm-headline__h2__subheadline orm-relative">
          {{ stripHTML(data[env.VUE_APP_RESERVATION_CARCATEGORY]) }}
          <i class="fal fa-question-circle orm-cargroup__tooltip"
            ><span
              class="orm-cargroup__tooltip_text orm-cargroup__tooltip-bottom"
              >{{ i18n("cargroup/noguarantee") }}</span
            ></i
          >
        </p>
        <div
          v-if="
            store.getters['ORMgeneral/GET_PARAMETER'](
              'BORMLF_STEP1_SHOW_ADD_TEXT'
            ) == '1'
          "
          v-html="data[env.VUE_APP_RESERVATION_CARTEXT]"
        ></div>
      </div>
      <!-- !!! -->
      <div v-if="!loading">
        <div class="orm-cardetails" v-if="price.length > 0">
          <div class="orm-carequip">
            <p class="orm-equip__txt__icons">
              <equipIcon :data="data.features" :shortlist="true" />
            </p>
            <p class="orm-equip__txt__freemiles">
              <span v-if="price && !price[0].all_km_inclusive"
                >{{ i18n("cargroup/inclusive") }} {{ price[0].km_free }}
                {{ i18n("cargroup/freeKilometers") }}</span
              >
              <span v-else
                >{{ i18n("cargroup/inclusive") }}
                {{ i18n("cargroup/unlimited") }}
                {{ i18n("cargroup/freeKilometers") }}</span
              >
            </p>
          </div>
          <div v-if="this.$store.getters['ORMgeneral/GET_PARAMETER']('BORMLF_STEP1_SHOW_TOTALPRICE_ONLY') !== '1'" class="orm-carprice">
            <div>
              <!-- Überschrift für den Tagespreis oder Gesamtpreis -->
              <p class="orm-price__txt__surtitle">
                {{
                  switchTotalLongPricePosition
                      ? i18n("cargroup/total")
                      : `${i18n("cargroup/unitbefore")} ${price[0]?.unit} ${i18n("cargroup/unitafter")}`
                }}
              </p>

              <!-- Tagespreis oder Gesamtpreis (abhängig von switchTotalLongPricePosition) -->
              <p class="orm-price__txt" :class="{ 'orm-price__txt--offer': isOffer }">
                <span style="white-space: nowrap">
                  {{
                    convertCurrency(
                        switchTotalLongPricePosition
                            ? (showNettoPrice
                                ? tarif?.end_positions?.[0]?.total_price
                                : tarif?.total_price_main_rates)
                            : (showNettoPrice
                                ? price?.[0]?.single_price
                                : price?.[0]?.long_price)
                    )
                  }}
                </span>
              </p>

              <!-- Ladesymbol, wenn der Preis noch nicht geladen wurde -->
              <p class="orm-price__txt" v-if="price.length === 0 && loading">
                <i class="fa fa-spinner-third orm-rotate360"></i>
              </p>

              <!-- Zusatzinfo für den Tagespreis oder Gesamtpreis -->
              <p class="orm-price__txt__subtitle">
                {{
                  switchTotalLongPricePosition
                      ? `${i18n("cargroup/unitbefore")} ${price[0]?.unit} ${i18n("cargroup/unitafter")}: ${convertCurrency(showNettoPrice ? price[0]?.single_price : price[0]?.long_price)}`
                      : `(${i18n("cargroup/total")}: ${convertCurrency(showNettoPrice ? tarif?.end_positions?.[0]?.total_price : tarif?.total_price_main_rates)})`
                }}
              </p>
            </div>
          </div>

          <!-- Zweig für den Fall, dass der Parameter 'BORMLF_STEP1_SHOW_TOTALPRICE_ONLY' auf '1' gesetzt ist -->
          <div v-else class="orm-carprice">
            <div>
              <!-- Nur Gesamtpreis anzeigen -->
              <p class="orm-price__txt__surtitle">
                {{ i18n("cargroup/total") }}
              </p>
              <p class="orm-price__txt" :class="{ 'orm-price__txt--offer': isOffer }">
                <span style="white-space: nowrap">
                  {{
                    convertCurrency(
                        showNettoPrice
                            ? tarif?.end_positions?.[0]?.total_price
                            : tarif?.total_price_main_rates
                    )
                  }}
                </span>
              </p>

              <!-- Ladesymbol -->
              <p class="orm-price__txt" v-if="price.length === 0 && loading">
                <i class="fa fa-spinner-third orm-rotate360"></i>
              </p>
            </div>
          </div>



        </div>
        <div class="orm-carbutton">
          <button
            v-if="price.length > 0 && !loading"
            @click="setCarGroup(car)"
            class="orm-button__cta small"
            :class="isOffer ? 'orm-button__cta--offer' : 'outline'"
          >
            {{
              isOffer
                ? i18n("cargroup/select_offer") || "Angebot sichern"
                : i18n("cargroup/select")
            }}<i
              v-if="isOffer"
              class="orm-button__cta--offer-icon far fa-stars"
            ></i>
          </button>
          <div class="orm-car__error" v-if="price.length == 0 && !loading">
            <button
              class="orm-button__cta outline small"
              @click="openContactModal(car)"
            >
              {{ i18n("cargroup/error/button") }}
            </button>
            {{ i18n("cargroup/error/price") }}
          </div>
        </div>
      </div>
      <div class="orm-price__txt text-center orm-mb-32 orm-mt-32" v-else>
        <i class="fa fa-spinner-third orm-rotate360"></i>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import store from "@/store";
import equipIcon from "@/components/reservation/equip-icon.vue";
import Slider from "@/components/ui/image-slider.vue";
import { convertCurrency } from "@/constants/formater";
import i18n from "@/mixins/mixins";
import stripHTML from "@/mixins/mixins";
import { buildDataLayer } from "@/constants/analytics";
import { routeToSteps } from "@/constants/getRoutes";

export default defineComponent({
  name: "car-list-small",
  components: { equipIcon, Slider },
  mixins: [i18n, stripHTML],
  setup() {
    const userSession = store.state.userSession.LocalSession;

    return {
      userSession,
      store,
      convertCurrency,
      routeToSteps,
    };
  },
  data() {
    return {
      car: Object,
      price: [],
      isOffer: false,
      images: null,
      show: true,
      loading: true,
      tarif: Object,
      env: process.env,
      switchTotalLongPricePosition: false,
      showNettoPrice: false,
    };
  },
  props: {
    data: Object,
    filter: Boolean,
  },
  async mounted() {
    const showNetto = await store.getters["ORMgeneral/GET_PARAMETER"](
      "BORM_SHOW_NETTO_PRICE"
    );

    switch (showNetto) {
      case "1":
        this.showNettoPrice = true;
        break;
      default:
        break;
    }
    this.car = await JSON.parse(JSON.stringify(this.data));
    this.car.price = {};

    const pricePosition = await store.getters["ORMgeneral/GET_PARAMETER"](
      "BORM_GESAMTPREIS_FETT"
    );

    switch (pricePosition) {
      case "1":
        this.switchTotalLongPricePosition = true;
        break;
      default:
        break;
    }
    const observer = new IntersectionObserver((entries) => {
      // Use `intersectionRatio` because of Edge 15's
      // lack of support for `isIntersecting`.
      // See: https://github.com/w3c/IntersectionObserver/issues/211
      if (entries[0].intersectionRatio <= 0) return;
      // Cleanup the observer when it's not
      // needed anymore.
      observer.unobserve(this.$el);
      // The `loadPrice()` resolves
      // to the result of a dynamic `import()`
      // which is passed to the `resolveComponent()`
      // function.
      this.lazyload();
    });
    // We observe the root `$el` of the
    // mounted loading component to detect
    // when it becomes visible.
    observer.observe(this.$el);
  },
  emits: ["openContact"],
  methods: {
    async lazyload() {
      const car = [];

      // await store
      //   .dispatch("cargroup/SET_CARGROUP_IMAGE", this.car.id)
      //   .then((val) => (this.images = val));
      this.images = this.car.images;
      this.tarif = await store
        .dispatch("reservation/CALCULATE_PRICE", {
          id: this.car.id,
          extras: false,
        })
        .then((res) => {
          if (!res.errors) {
            res.main_rates.forEach((element) => {
              if (element.position == 1) {
                car.push(element);
                if (element.is_offer) this.isOffer = true;
              }
            });
            this.loading = false;
            // console.log('tarif',res);
            return res;
          } else {
            this.loading = false;
            this.$emit("update:error", res);
          }
        });

      this.price = car;
    },
    setCarGroup(car) {
      store.dispatch("userSession/SET_CARGROUP", car.id).then(() => {
        store
          .dispatch("reservation/SET_RESERVATION_TARIFS", this.tarif)
          .then(() => {
            if (this.isOffer) buildDataLayer("view_promotion", {}, null);
            routeToSteps(this, 2);
          });
      });
    },
    openContactModal(car) {
      this.$emit("openContact", car);
    },
  },
});
</script>
